
import { Enums } from '@bode-canada/core';
import { TypographyType } from '@/ui-kit/components/typography/enums';
import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import ExternalLink from '@/ui-kit/components/external-link';
import Typography from '@/ui-kit/components/typography';
import Carousel from '@/ui-kit/components/carousel';
import CarouselItem from '@/ui-kit/components/carousel-item';
import { ListingPageEvent } from '@/constants/AnalyticEvents';
import { ViewListingAction } from '@/components/listing-card/helpers/actions';
import ListingCard from '@/components/listing-card';
import { CAROUSEL_BREAKPOINTS } from './constants';

export default {
  name: 'ListingComparable',
  components: {
    ExternalLink,
    Typography,
    Carousel,
    CarouselItem,
    ListingCard,
  },
  props: {
    title: {
      type: String,
      default: 'Comparables',
    },
    listings: {
      type: Array,
      required: true,
    },
    comparableLink: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      TypographyType,
      StyleColorSchemeType,
      CAROUSEL_BREAKPOINTS,
    };
  },
  methods: {
    getViewListingAction({ origin }) {
      const analyticEvent = origin === Enums.ListingOriginEnum.BODE
        ? ListingPageEvent.BodeComparable
        : ListingPageEvent.MLSComparable;

      return new ViewListingAction({ analyticEvent });
    },
  },
};
